import { z } from 'zod';

// ADR-007 : code court, unique et immuable du tenant.
export const tenantCodeSchema = z
  .string()
  .regex(/^[A-Z0-9]{3,8}$/, 'Le code tenant doit contenir 3 à 8 caractères A-Z ou 0-9');
